module.exports = __webpack_public_path__ + "img/idcard_1e.564dcf69.png";